import Yup from "../localizedYup";

const HousingScoringFormValidationModel = Yup.object().shape({
  partner: Yup.object({ id: Yup.number().required() }),
  dateOfApplication: Yup.date().required(),
  pointType: Yup.string().required(),
});

export { HousingScoringFormValidationModel };
